(() => {
  function flyToBag(dialog) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const destination = document.querySelector('#cart-icon-bubble');
    if (!destination || !dialog._flyFrom) return;
    const img = dialog.querySelector('.em-quick-image');
    const flyer = document.createElement('span');
    flyer.className = 'em-quick-fly';
    if (img?.src) flyer.style.backgroundImage = `url("${img.src}")`;
    const from = dialog._flyFrom;
    const to = destination.getBoundingClientRect();
    flyer.style.left = `${from.x - 24}px`;
    flyer.style.top = `${from.y - 24}px`;
    document.body.appendChild(flyer);
    const dx = to.left + to.width / 2 - from.x;
    const dy = to.top + to.height / 2 - from.y;
    flyer.animate([
      { transform: 'translate(0, 0) scale(1)', opacity: 1 },
      { transform: `translate(${dx}px, ${dy}px) scale(.25)`, opacity: 0.25 }
    ], { duration: 620, easing: 'cubic-bezier(.2,.75,.3,1)', fill: 'forwards' })
      .finished.finally(() => flyer.remove());
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-em-quick-open]');
    if (opener) {
      event.preventDefault();
      const dialog = document.getElementById(opener.dataset.emQuickOpen);
      if (!dialog) return;
      dialog._opener = opener;
      dialog.showModal();
      dialog.querySelector('[data-em-quick-variant]:not(:disabled)')?.focus();
      return;
    }
    const close = event.target.closest('[data-em-quick-close]');
    if (close) {
      close.closest('dialog')?.close();
      return;
    }
    const option = event.target.closest('[data-em-quick-variant]');
    if (option && !option.disabled) {
      const dialog = option.closest('dialog');
      dialog.querySelectorAll('[data-em-quick-variant]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button === option));
      });
      dialog.querySelector('input[name="id"]').value = option.dataset.emQuickVariant;
      const submit = dialog.querySelector('.em-quick-submit');
      submit.disabled = false;
      submit.removeAttribute('aria-label');
      return;
    }
    if (event.target.matches('dialog.em-quick-dialog')) event.target.close();
  });

  document.addEventListener('submit', (event) => {
    const dialog = event.target.closest('dialog.em-quick-dialog');
    if (!dialog) return;
    const variantId = dialog.querySelector('input[name="id"]')?.value;
    if (!variantId) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const rect = dialog.querySelector('.em-quick-submit').getBoundingClientRect();
    dialog._flyFrom = { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
    dialog.dataset.submitting = variantId;
  }, true);

  document.addEventListener('close', (event) => {
    const dialog = event.target;
    if (!dialog.matches?.('dialog.em-quick-dialog')) return;
    if (!dialog.dataset.added) dialog._opener?.focus();
    delete dialog.dataset.added;
    delete dialog.dataset.submitting;
  }, true);

  function connectCartEvents() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
      if (data.source !== 'product-form') return;
      document.querySelectorAll('dialog.em-quick-dialog[open][data-submitting]').forEach((dialog) => {
        if (dialog.dataset.submitting !== String(data.productVariantId)) return;
        dialog.dataset.added = 'true';
        flyToBag(dialog);
        dialog.close();
      });
    });
    subscribe(PUB_SUB_EVENTS.cartError, (data) => {
      document.querySelectorAll('dialog.em-quick-dialog[open][data-submitting]').forEach((dialog) => {
        if (dialog.dataset.submitting === String(data.productVariantId)) delete dialog.dataset.submitting;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connectCartEvents, { once: true });
  else connectCartEvents();
})();
